import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../lib/apiFetch";

export const PLAN_LABELS = {
  free:         "Trial",
  trial:        "Trial",
  starter:      "Starter",
  pro:          "Professional",
  professional: "Professional",
  agency:       "Scale",
  pilot:        "Pilot",
};

const UserContext = createContext(null);

export function UserProvider({ session, children }) {
  const [userProfile, setUserProfile] = useState({ plan: null, credits: null, free_page_audits: null, auto_updates_paused: false });

  useEffect(() => {
    if (!session) return;
    apiFetch("/me")
      .then(r => r.json())
      .then(data => setUserProfile(data))
      .catch(err => console.warn("UserContext /me error:", err));
  }, [session?.user?.id]);

  const setPauseUpdates = async (paused) => {
    setUserProfile(p => ({ ...p, auto_updates_paused: paused })); // optimistic
    try {
      const r = await apiFetch("/me/pause-updates", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ paused }),
      });
      if (!r.ok) throw new Error("request failed");
    } catch (err) {
      console.warn("setPauseUpdates error:", err);
      setUserProfile(p => ({ ...p, auto_updates_paused: !paused })); // revert
    }
  };

  return (
    <UserContext.Provider value={{ ...userProfile, setPauseUpdates, refreshProfile: () => {
      apiFetch("/me").then(r => r.json()).then(setUserProfile).catch(() => {});
    }}}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
